import * as Sentry from "@sentry/react";

// Sentry configuration
export const SENTRY_CONFIG = {
  // You'll need to replace this with your actual Sentry DSN
  // Get this from your Sentry project settings at https://sentry.io/settings/projects/
  DSN: "https://4a1ab7ca1385322b1fbec1b61e81c807@o4509407286001664.ingest.us.sentry.io/4510032780525568", // Replace with your actual DSN

  // Environment configuration - you can change this based on your deployment
  ENVIRONMENT: window.location.hostname === "survey.wiseradvisor.com" ? "production" : "development", // Change to "development" for local testing

  // Release version (you can customize this)
  RELEASE: "1.0.0",

  // Sample rate for performance monitoring (0.0 to 1.0) - disabled for now
  TRACES_SAMPLE_RATE: 0.0, // Disabled - no performance monitoring

  // Sample rate for error monitoring (0.0 to 1.0)
  SAMPLE_RATE: 1.0, // Capture all errors
};

// Initialize Sentry
export const initSentry = () => {
  Sentry.init({
    dsn: SENTRY_CONFIG.DSN,
    environment: SENTRY_CONFIG.ENVIRONMENT,
    release: SENTRY_CONFIG.RELEASE,
    // No integrations needed for basic error monitoring
    // Performance Monitoring
    tracesSampleRate: SENTRY_CONFIG.TRACES_SAMPLE_RATE,
    // Error Monitoring
    sampleRate: SENTRY_CONFIG.SAMPLE_RATE,
    // Additional options
    beforeSend(event, hint) {
      // Filter out certain errors if needed
      if (event.exception) {
        const error = hint.originalException;
        // Don't send errors from browser extensions
        if (error && error.message && error.message.includes("Non-Error promise rejection")) {
          return null;
        }
      }
      return event;
    },
    // Set user context
    beforeBreadcrumb(breadcrumb) {
      // Filter out certain breadcrumbs if needed
      if (breadcrumb.category === "console" && breadcrumb.level === "log") {
        return null;
      }
      return breadcrumb;
    },
  });
};

// Helper function to set user context
export const setSentryUser = (userId, userInfo = {}) => {
  Sentry.setUser({
    id: userId,
    ...userInfo,
  });
};

// Helper function to add custom tags
export const setSentryTags = (tags) => {
  Sentry.setTags(tags);
};

// Helper function to add custom context
export const setSentryContext = (key, context) => {
  Sentry.setContext(key, context);
};

// Helper function to capture exceptions
export const captureException = (error, context = {}) => {
  Sentry.withScope((scope) => {
    Object.keys(context).forEach((key) => {
      scope.setContext(key, context[key]);
    });
    Sentry.captureException(error);
  });
};

// Helper function to capture messages
export const captureMessage = (message, level = "info", context = {}) => {
  Sentry.withScope((scope) => {
    Object.keys(context).forEach((key) => {
      scope.setContext(key, context[key]);
    });
    Sentry.captureMessage(message, level);
  });
};
